export const sidebarFontColor = "#6C6B6B";
export const colorBlack = "#000000";
export const colorWhite = "white";
export const primaryColor = "#38369C";
export const colorFontRed = "#E74242";

export const bgColor = "#F9F9FB";

export const dodgerColor = "dodgerblue";

export const secondaryColor = "#FF9800";

export const colorDarkRed = "#E74242";
export const colorLightRed = "rgba(231, 66, 66, 0.1)";

export const colorDarkGreen = "#3FA92F";
export const colorLightGreen = "rgba(63, 169, 47, 0.1)";

export const colorDarkBlue = "#38369C";
export const colorLightBlue = "rgba(56, 54, 156, 0.1)";

export const colorLightGrey = "#F3F3F3";

export const colorLightYellow = "#fae9d9";
export const colorDarkYellow = "#F29339";
